var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Card"},[(_vm.thumbnail)?_c('img',{attrs:{"src":_vm.thumbnail,"alt":_vm.alt}}):_vm._e(),_c('div',{staticClass:"CardContent"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }